package io.horion.cv.components.forms



import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.cards.GenericFormCardNew
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.dynamicfields.DynamicAddForm
import io.horion.cv.components.widgets.AjouterBoutton
import io.horion.cv.di.koinGet
import io.horion.cv.models.Job
import io.horion.cv.models.Responsability
import io.horion.cv.utils.Colors
import io.horion.cv.viewModel.JobViewModel
import org.jetbrains.compose.web.css.px



@OptIn(DelicateApi::class)
@Composable
fun ResponsabilityContent() {
    val jobViewModel = koinGet<JobViewModel>()
    val jobUiState = jobViewModel.jobUiState
    val responsabiltyFromVM = jobUiState.currentJob.responsibilities
    val breakpoint = rememberBreakpoint()

    LaunchedEffect(Unit) {
        if (responsabiltyFromVM.isEmpty()) {
            jobViewModel.updateResponsibility(0, "")
            jobViewModel.editingResponsability = "responsability-0"
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        responsabiltyFromVM.forEachIndexed { index, responsability ->
            val tempId = "responsability-$index"

            val responsabilityobj = remember(responsability) {
                Responsability(id = tempId, responsability = responsability)
            }

            GenericFormCardNew(
                item = responsabilityobj,
                isEditing = jobViewModel.editingResponsability == tempId,
                onEdit = { jobViewModel.editingResponsability = tempId },
                onDelete = {
                    jobViewModel.deleteResponsibility(index)
                    if (jobViewModel.jobUiState.currentJob.responsibilities.isEmpty()) {
                        jobViewModel.updateResponsibility(0, "")
                        jobViewModel.editingResponsability = "Responsability-0"
                    } else {
                        jobViewModel.editingResponsability = null
                    }
                },
                onComplete = { jobViewModel.editingResponsability = null },
                getSummary = { rs ->
                    if (rs.responsability.isNotBlank()) {
                        SummaryData(title = rs.responsability, subtitle = "")
                    } else null
                },
                getDefaultText = { "[Responsability ]" },
                formContent = { s, onDel, onComp ->
                    DynamicAddForm(
                        index = index,
                        onDelete = onDel,
                        onComplete = onComp,
                        label = "Responsability",
                        value = responsability,
                        onValueChange = { resp ->
                            jobViewModel.updateResponsibility(index,resp)
                        }
                    )
                },
                isMobile = breakpoint <= Breakpoint.MD,
                isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD
            )
        }


        AjouterBoutton(
            text = "Ajouter une responsability ",
            onClick = {
                val nextIndex = responsabiltyFromVM.size
                jobViewModel.updateResponsibility(nextIndex, "")
                jobViewModel.editingResponsability = "responsability-$nextIndex"
            },
            isMobile = breakpoint < Breakpoint.SM,
            isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD,
            color = Colors.black
        )
    }
}